import { combineReducers } from 'redux';
import homeReducer from '../modules/home/reducers';

const rootReducers = combineReducers({
  homeReducer,
});

export default rootReducers;
